import api from "../api/axios";

export const getAllIncreament = async (id) => {
  try {
    const response = await api.get(`mypays/employee/${id}/increments`);
    return response.data;
  } catch (error) {
    console.error("Error fetching Increament:", error);
    throw error;
  }
};
